import { WorkItemResult } from "@buzzeasy/shared-frontend-utilities";
import { CalendarX, Check, CircleQuestionMark, CircleX, LucideIcon, PhoneMissed, PhoneOff, TriangleAlert } from "lucide-react";
import { ReactElement } from "react";

const mapResultToIcon: Record<WorkItemResult | "default", LucideIcon> = {
  Handled: Check,
  Abandoned: PhoneOff,
  Failed: TriangleAlert,
  Cancelled: CalendarX,
  Rejected: CircleX,
  Missed: PhoneMissed,
  default: CircleQuestionMark,
};

export function getWorkItemResultIcon(result: WorkItemResult, size: number): ReactElement {
  const IconComponent = mapResultToIcon[result] ?? mapResultToIcon["default"];
  return <IconComponent size={size} />;
}

export function getResultTagColor(result: WorkItemResult): string {
  switch (result) {
    case "Handled":
      return "#237804";
    case "Missed":
      return "#D48806";
    case "Abandoned":
      return "#A8071A";
    case "Failed":
      return "#AD4E00";
    case "Rejected":
      return "#F5222D";
    case "Cancelled":
    default:
      return "#5A5A5A";
  }
}

export function getResultTagBackgroundColor(result: WorkItemResult): string {
  const color = getResultTagColor(result);
  return `${color}0D`;
}
